import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Content from '../Content/Content';
import useIsShowWishCard from '../../model/hooks/useIsShowWishCard';
import Background from '../Background/Background';
import useReset from '../../model/hooks/useReset';
import useIsPendingWish from '../../model/hooks/useIsPendingWish';
import AppLoader from '../../../../features/appLoader/AppLoader';

export default function Wish() {
  const isShowWishCard = useIsShowWishCard();
  const isPending = useIsPendingWish();
  useReset();

  return (
    <div className={'wish'}>
      <Background />
      <div className={'wish__wrapper'}>
        <SwitchTransition>
          <CSSTransition
            key={Number(isShowWishCard)}
            timeout={300}
            classNames={'wish__content'}
            mountOnEnter
            unmountOnExit
            appear
          >
            <Content isHiddenWishCard={!isShowWishCard} />
          </CSSTransition>
        </SwitchTransition>
      </div>
      {isPending && <AppLoader />}
    </div>
  );
}
